import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// import DoctorListComponent from 'src/components/views/Doctor/DoctorListPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import DoctorList from 'src/components/views/Doctor/DoctorList';

const mapStateToProps = ({ userState: { isAgent, userInfo, isDomestic }, drugStoreState: { drugStores } }: IStoreState) => ({
  isAgent,
  isDomestic,
  userInfo,
  drugStores,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorList);



// WEBPACK FOOTER //
// ./src/containers/DoctorList.ts